'use client';
import React from 'react';
import { ExplorerContextProvider } from '@context/explorer';
import {
  UnsavedChangesProvider,
  useUnsavedChanges,
} from '@/context/unsavedChanges';
import ClientAuthProvider from '@/auth/ClientAuthProvider';
import UnsavedChangesDialog from '@/components/ui/UnsavedChangesDialog';
import { Pendo } from '@components/_components/ui/Pendo';
import ApiExplorerLandingKvl from '@/components/_components/ui/ApiExplorerLandingKvl';

const UnsavedChangesDialogRenderer: React.FC = () => {
  const { dialogState } = useUnsavedChanges();

  return (
    <UnsavedChangesDialog
      open={dialogState.open}
      onOpenChange={dialogState.onOpenChange}
      onConfirm={dialogState.onConfirm}
      onCancel={dialogState.onCancel}
      variant={dialogState.variant}
    />
  );
};

const ExplorerLayout: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <ClientAuthProvider>
      <ExplorerContextProvider>
        <Pendo />
        <ApiExplorerLandingKvl />
        <UnsavedChangesProvider>
          {children}
          <UnsavedChangesDialogRenderer />
        </UnsavedChangesProvider>
      </ExplorerContextProvider>
    </ClientAuthProvider>
  );
};

export default ExplorerLayout;
